<template>
  <div>

    <stat-prices-trend></stat-prices-trend>

    <stat-prices></stat-prices>

  </div>
</template>

<script>

  import StatPrices from "./Prices/Period"
  import StatPricesTrend from "./Prices/Trend"

  export default {
    name: "MarketStatistics",
    components: {StatPricesTrend, StatPrices},
  }
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/Dashboard/Statistics/Market/Index.vue